export default {
  title: 'Providing funds',
  fundProvision: 'Providing funds'
}
